import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import PageHeader from '../common/PageHeader/PageHeader'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import PricingTab from './PricingTab/PricingTab'
import CommunityLandingPageTab from './CommunityLandingPageTab/CommunityLandingPageTab'

import classes from './CommunitySettingsPage.module.scss'
import { setCurrentTab } from '../../actions/commonActions'

const tabsData = [
  {
    name: 'Pricing & Packages',
    body: <PricingTab />,
  },
  {
    name: 'Landing Page',
    body: <CommunityLandingPageTab />,
  },
]

const CommunitySettingsPage = () => {
  const dispatch = useDispatch()

  const isLoadingUserRefresh = useSelector(state => state.loading.isLoading)

  useEffect(() => {
    dispatch(setCurrentTab('Community-Settings'))
  }, [dispatch])

  if (isLoadingUserRefresh === false) {
    return (
      <div className={classes['community-settings-page']}>
        <PageHeader title='Community Settings' />
        <Tabs className={classes['tabs']} selectedTabClassName={classes['selected-tab']} selectedTabPanelClassName={classes['selected-tab-panel']}>
          <TabList className={classes['tab-list']}>
            {tabsData.map(tabData => (
              <Tab key={tabData.name} className={classes['tab']}>{tabData.name}</Tab>
            ))}
          </TabList>

          {tabsData.map(tabsData => (
            <TabPanel key={tabsData.name}>
              {tabsData.body}
            </TabPanel>
          ))}
        </Tabs>
      </div>
    )
  }

  return <Loader message='Loading Community Settings...' />
}

export default CommunitySettingsPage
